import { Component, Input } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { STRING_CONSTANTS } from '@config/constants/string.constants';

/**
 * Kartu ringkasan satu angka: label + ikon info opsional + nilai besar.
 * Nilai diterima sudah terformat (BE monitoring mengirim string siap render).
 */
@Component({
  selector: 'app-card-summary-info',
  templateUrl: './card-summary-info.component.html',
  styleUrls: ['./card-summary-info.component.scss'],
})
export class CardSummaryInfoComponent {
  @Input() label = '';
  @Input() value: string | null | undefined = null;
  /** Teks tooltip ikon info. Kosong = ikon tidak dirender. */
  @Input() info = '';
  @Input() isLoading: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  @Input() labelSkeletonWidth = 150;
  @Input() valueSkeletonWidth = 200;

  protected readonly STRING_CONSTANTS = STRING_CONSTANTS;
}
